import moment from 'moment';
import styles from './HouseAcceptanceNoticeForm.module.scss';

export const defaultDate = moment().format('YYYY-MM-DD');

export const fieldNames = {
  rangePicker: 'rangePicker',
  includeWeekend: 'includeWeekend',
  intervalId: 'intervalId',
  startTime: 'startTime',
  endTime: 'endTime',
  withLunchBreak: 'withLunchBreak',
  lunchStartTime: 'lunchStartTime',
  lunchEndTime: 'lunchEndTime',
  masterId: 'masterId',
  workerIds: 'workerIds',
};

export const HOUR_INTERVAL_ID = 2;

export const timePickerProps = {
  format: 'HH:mm',
  hideDisabledOptions: true,
  className: styles.picker,
  allowClear: false,
};
